import type { JSX } from "react";
export type SellTradeFormType = {
  id?: string;
  offer: OfferType;
  wantedProducts: WantedProductType[];
  offeredProducts: OfferedProductType[];
};

export type WantedProductType = {
  productId: string;
  brandName: string;
  productName: string;
  refNumber: string;
  comment: string;
};

export type OfferedProductType = {
  condition: number | undefined;
  brandName: string;
  productName: string;
  refNumber: string;
  comment: string;
  hasPaper: boolean;
  hasBox: boolean;
  price?: string;
  currency?: string;
  images?: ImageType[];
};

export type OfferType = {
  offerType: number;
  email: string | null;
  phoneCode: string;
  phone: string | null;
  country: string;
  firstName?: string;
  lastName?: string;
  comment?: string;
};

export type OptionType = {
  id?: string;
  value?: string;
  label: string | JSX.Element;
};

export enum OfferTypeEnum {
  Buy,
  Trade,
  Sell,
  Commission,
}

export enum OfferStatusEnum {
  New,
  InProgress,
  Processed,
  Closed,
}

export enum ContactUsStatusEnum {
  New,
  InProgress,
  Processed,
  Closed,
}

export enum ServiceOrderStatusEnum {
  New,
  InProgress,
  Processed,
  Closed,
}

export enum ConditionEnum {
  New,
  Mint,
  Old,
}

export type ImageType = {
  id: string;
  data: string;
  name: string;
  size: string;
  type: string;
  preview?: string;
  displayOrder?: number;
};
